import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthStateService } from '../services/auth/auth-state.service';
export class NotAuthInterceptor implements HttpInterceptor {
    authStateService = inject(AuthStateService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error) => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    return this.authStateService.notAuthorized().pipe(switchMap(() => throwError(() => error)));
                }

                return throwError(() => error);
            })
        );
    }
}
